import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { RevenueVsExpensesInsightsEntity } from "../entities/RevenueVsExpensesInsightsEntity";

export class GetRevenueVsExpensesInsightsUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<RevenueVsExpensesInsightsEntity> {
    return this.repository.getRevenueVsExpensesInsights();
  }
}
